var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.liveAgentTickets),function(t,index){return _c('live-agent-ticket',{key:index,attrs:{"ticket":t,"ticket-id":t.id,"departments":_vm.dirtyFetchedDepartments},on:{"message-created":_vm.message_created}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }